/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetEventSignup,
  FleetEventSignupAssignInput,
  FleetEventSignupCreateInput,
  FleetEventSignupUpdateInput,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Withdraw a member's signup (admin)
 */
export const destroyFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-signups/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyFleetEventSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEventSignup>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyFleetEventSignup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEventSignup>>>

    export type DestroyFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Withdraw a member's signup (admin)
 */
export const useDestroyFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEventSignup>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEventSignup>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Admin: assign or update a signup
 */
export const assignFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupAssignInput: MaybeRefOrGetter<FleetEventSignupAssignInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupAssignInput = toValue(fleetEventSignupAssignInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-signups/${id}/assign`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupAssignInput, signal
    },
      );
    }




export const getAssignFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,{id: string;data: FleetEventSignupAssignInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,{id: string;data: FleetEventSignupAssignInput}, TContext> => {

const mutationKey = ['assignFleetEventSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignFleetEventSignup>>, {id: string;data: FleetEventSignupAssignInput}> = (props) => {
          const {id,data} = props ?? {};

          return  assignFleetEventSignup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof assignFleetEventSignup>>>
    export type AssignFleetEventSignupMutationBody = FleetEventSignupAssignInput
    export type AssignFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Admin: assign or update a signup
 */
export const useAssignFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignFleetEventSignup>>, TError,{id: string;data: FleetEventSignupAssignInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof assignFleetEventSignup>>,
        TError,
        {id: string;data: FleetEventSignupAssignInput},
        TContext
      > => {
      return useMutation(getAssignFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Sign up for slot
 */
export const signupFleetEventSlot = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupCreateInput: MaybeRefOrGetter<FleetEventSignupCreateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupCreateInput = toValue(fleetEventSignupCreateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupCreateInput, signal
    },
      );
    }




export const getSignupFleetEventSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,{id: string;data: FleetEventSignupCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,{id: string;data: FleetEventSignupCreateInput}, TContext> => {

const mutationKey = ['signupFleetEventSlot'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signupFleetEventSlot>>, {id: string;data: FleetEventSignupCreateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  signupFleetEventSlot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupFleetEventSlotMutationResult = NonNullable<Awaited<ReturnType<typeof signupFleetEventSlot>>>
    export type SignupFleetEventSlotMutationBody = FleetEventSignupCreateInput
    export type SignupFleetEventSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Sign up for slot
 */
export const useSignupFleetEventSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEventSlot>>, TError,{id: string;data: FleetEventSignupCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof signupFleetEventSlot>>,
        TError,
        {id: string;data: FleetEventSignupCreateInput},
        TContext
      > => {
      return useMutation(getSignupFleetEventSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Update own signup
 */
export const updateFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
    fleetEventSignupUpdateInput: MaybeRefOrGetter<FleetEventSignupUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
fleetEventSignupUpdateInput = toValue(fleetEventSignupUpdateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,{id: string;data: FleetEventSignupUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,{id: string;data: FleetEventSignupUpdateInput}, TContext> => {

const mutationKey = ['updateFleetEventSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventSignup>>, {id: string;data: FleetEventSignupUpdateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateFleetEventSignup(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventSignup>>>
    export type UpdateFleetEventSignupMutationBody = FleetEventSignupUpdateInput
    export type UpdateFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update own signup
 */
export const useUpdateFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventSignup>>, TError,{id: string;data: FleetEventSignupUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventSignup>>,
        TError,
        {id: string;data: FleetEventSignupUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Withdraw own signup
 */
export const withdrawFleetEventSignup = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/fleet-event-slots/${id}/signup`, method: 'DELETE', signal
    },
      );
    }




export const getWithdrawFleetEventSignupMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,{id: string}, TContext> => {

const mutationKey = ['withdrawFleetEventSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  withdrawFleetEventSignup(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawFleetEventSignupMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawFleetEventSignup>>>

    export type WithdrawFleetEventSignupMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Withdraw own signup
 */
export const useWithdrawFleetEventSignup = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawFleetEventSignup>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof withdrawFleetEventSignup>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getWithdrawFleetEventSignupMutationOptions(options), queryClient);
    }
    /**
 * @summary Sign up to event without picking a slot
 */
export const signupFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventSignupCreateInput: MaybeRefOrGetter<FleetEventSignupCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventSignupCreateInput = toValue(fleetEventSignupCreateInput);

      return axiosClient<FleetEventSignup>(
      {url: `/fleets/${fleetSlug}/events/${slug}/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventSignupCreateInput, signal
    },
      );
    }




export const getSignupFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventSignupCreateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventSignupCreateInput}, TContext> => {

const mutationKey = ['signupFleetEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof signupFleetEvent>>, {fleetSlug: string;slug: string;data: FleetEventSignupCreateInput}> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  signupFleetEvent(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SignupFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof signupFleetEvent>>>
    export type SignupFleetEventMutationBody = FleetEventSignupCreateInput
    export type SignupFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Sign up to event without picking a slot
 */
export const useSignupFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof signupFleetEvent>>, TError,{fleetSlug: string;slug: string;data: FleetEventSignupCreateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof signupFleetEvent>>,
        TError,
        {fleetSlug: string;slug: string;data: FleetEventSignupCreateInput},
        TContext
      > => {
      return useMutation(getSignupFleetEventMutationOptions(options), queryClient);
    }
